export default __webpack_public_path__ + "static/media/tpp-flea-tick-worming-delivery.15e3c5ff.svg";